import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from "react";
import { ParentValueComponentContext, ValueComponentContext, } from "@plansoft-configuration-renderer/layout";
import { thumbValueContentComponents } from "./thumbValueContentComponents";
export function ThumbnailValueComponentsProvider(props) {
    const existingComponents = useContext(ValueComponentContext);
    const mergedComponents = useMemo(() => (Object.assign(Object.assign({}, existingComponents), thumbValueContentComponents)), [existingComponents]);
    return (_jsx(ParentValueComponentContext.Provider, { value: existingComponents, children: _jsx(ValueComponentContext.Provider, { value: mergedComponents, children: props.children }) }));
}
//# sourceMappingURL=ThumbnailValueComponentsProvider.js.map